// extracted by mini-css-extract-plugin
module.exports = {"partnerButton":"PartnershipButton_partnerButton__25FJV","icon":"PartnershipButton_icon__2dPFN"};